import { render, staticRenderFns } from "./BuscaInstituicao.vue?vue&type=template&id=68273c67&scoped=true"
import script from "./BuscaInstituicao.vue?vue&type=script&lang=js"
export * from "./BuscaInstituicao.vue?vue&type=script&lang=js"
import style0 from "./BuscaInstituicao.vue?vue&type=style&index=0&id=68273c67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68273c67",
  null
  
)

export default component.exports